import { defaultFirmaTilsynFieldColumns } from "../../../../../config/firmaConfig";
import { firmaGennemfoerteTilsynForm } from "../../../../../config/form/firma/firmaGennemfoerteTilsynFormConfig";
import useActiveColumns from "../../../../../hooks/useActiveColumns";
import {
  createColumnEditorTrigger,
  getHeaderActiveColumns,
  TD,
} from "../../../../../util/table";
import { ModalProvider } from "../../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  TableRow,
} from "../../../../Table/TableBasic";
import IngenRegistreringer from "../../../person/id/IngenRegistreringer";
import OpretNyButtonBlock from "../../../person/id/OpretNyButtonBlock";
import { FirmaDto } from "../../../../../interfaces/schema";
import { SortBy } from "../../../../../interfaces/table";
import useLocalStorageState from "use-local-storage-state";
import { useContext } from "react";
import { UserQueryContext } from "../../../../../context/UserContext";
import { orderBy } from "../../../../../util/orderBy";
import ColumnEditorModal from "@/components/column-editor/ColumnEditorModal";

const defaultSortBy: SortBy[] = [
  {
    direction: "desc",
    field: "gennemfoerselDato",
  },
];

export default function FirmaGennemfoerteTilsyn({
  firma,
  firmaTilsyn,
  invalidateData,
}: {
  firma: FirmaDto;
  firmaTilsyn: FirmaDto["firmaTilsyn"];
  invalidateData: InvalidateDataFunction<any>;
}) {
  const { user, hasPermission } = useContext(UserQueryContext);
  const canWrite = hasPermission(user, "TilsynWrite");
  const [gennemfoerteTilsynColumns, setGennemfoerteTilsynActiveColumns] =
    useActiveColumns(
      "firma-gennemfoertetilsyn-active-columns",
      defaultFirmaTilsynFieldColumns,
    );

  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "firmaGennemfoerteTilsynSortBy",
    {
      defaultValue: defaultSortBy,
    },
  );

  if (firmaTilsyn?.length === 0) {
    return (
      <IngenRegistreringer
        invalidateData={invalidateData}
        editConfig={
          canWrite ? firmaGennemfoerteTilsynForm(firma.id) : undefined
        }
      />
    );
  }
  return (
    <ModalProvider>
      <TableRoot>
        <TableHead ColumnEditorTrigger={createColumnEditorTrigger()}>
          <>
            {getHeaderActiveColumns(gennemfoerteTilsynColumns, {
              defaultSortBy,
              setSortBy,
              sortBy,
            })}
          </>
        </TableHead>
        <TableBody>
          {orderBy(
            firmaTilsyn,
            sortBy.map((s) => s.field),
            sortBy.map((s) => s.direction),
          ).map((tilsyn, i) => {
            return (
              <TableRow
                key={i}
                editConfig={
                  canWrite
                    ? firmaGennemfoerteTilsynForm(firma.id, tilsyn.id)
                    : undefined
                }
                invalidateData={invalidateData}
              >
                <>
                  {gennemfoerteTilsynColumns
                    .filter((col) => col.active)
                    .map((col) => {
                      return <TD key={col.field} col={col} rowData={tilsyn} />;
                    })}
                </>
              </TableRow>
            );
          })}
        </TableBody>
      </TableRoot>
      <ColumnEditorModal
        defaultColumns={defaultFirmaTilsynFieldColumns}
        columns={gennemfoerteTilsynColumns}
        setActiveColumns={setGennemfoerteTilsynActiveColumns}
      />
      <OpretNyButtonBlock
        editConfig={
          canWrite ? firmaGennemfoerteTilsynForm(firma.id) : undefined
        }
        invalidateData={invalidateData}
      />
    </ModalProvider>
  );
}
